// extracted by mini-css-extract-plugin
export default {"wrapper":"ListWithActions_wrapper__kAuNB","block":"ListWithActions_block__Y8eX2","table":"ListWithActions_table__IOjLG"};